export enum WidgetActEnum {
  STEP = "@tiktok/STEP",
  MOBILE = "@tiktok/MOBILE",
  SETTING = "@tiktok/SETTING",
  GET_TAG_PRODUCTS = "@tiktok/TAG_PRODUCTS",
  COUNT = "@tiktok/COUNT",
  CHANGE_STATUS = "@tiktok/CHANGE_STATUS",
  RISE_SEQUENCENUMBER = "@tiktok/RISE_SEQUENCENUMBER",
  SEARCHING = "@tiktok/SEARCHING",
}
